export default __webpack_public_path__ + "static/media/alu_cat.f4458323.jpg";